import React from 'react';
import {
    KatAppLayout,
    KatNavigation,
    KatNavigationSection,
    KatDivider,
} from '@amzn/katal-react';
import TestPilotHeader from './TestPilotHeader';
import TestPilotTabs from './TestPilotTabs';
import './css/testPilot.css';

interface TestPilotPageProps {}

const TestPilotPage: React.FC<TestPilotPageProps> = ({}) => {
    return (
        <KatAppLayout standalone>
            {/* Header with logo and title */}
            <TestPilotHeader slot="header" />

            {/* Left nav: always open, no toggle arrow */}
            <KatNavigation slot="left" mode="vertical">
                <KatNavigationSection>
                    <span slot="label">TestPilot Tips</span>
                    <a href="#">Onboard new entities</a>
                    <a href="#">How to find test data</a>
                    <a href="#">How to track test payment</a>
                    <a href="#">Troubleshooting</a>
                </KatNavigationSection>
            </KatNavigation>

            {/* Main content with scaled layout */}
            <div className="app-zoomed-out content-section">
                <TestPilotTabs />
            </div>

            <KatDivider variant="athens" />

            {/* Footer */}
            <footer slot="bottom" className="test-pilot-footer">
                <div className="footer-content">
                    <span>© 2025 TestPilot - Payment Testing Tool</span>
                </div>
            </footer>
        </KatAppLayout>
    );
};

export default TestPilotPage;